export const SET_IS_AUTH = "SET_IS_AUTH";
export const RESET_AUTH_REDUCER = "RESET_AUTH_REDUCER";
export const SET_AUTH_ERROR = "SET_AUTH_ERROR";
export const RESET_USER_REDUCER = "RESET_USER_REDUCER";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const SET_DESIGNATIONS = "SET_DESIGNATIONS";
export const SET_DEPARTMENTS = "SET_DEPARTMENTS";
